import createReducer from 'redux/lib/reducerConfig';

const ActionTypes = {
  LOAD_COMPANY_JOB_FILES: 'COMPANY_JOBS/LOAD_COMPANY_JOB_FILES',
};

export const initialState = {
  data: [],
};

export const filesReducer = createReducer(
  initialState,
  {
    [ActionTypes.LOAD_COMPANY_JOB_FILES]: (state, { payload }) => {
      return { ...state, data: payload };
    },
  },
);
